import React from 'react'
import Table from '../../components/common/Table'
import { ForfeitureReasonDTO } from '../../services/apiClient'
import { convertToUserTime } from '../../utils/dateUtils/convertToUserTime'
import { renderBooleanBadge } from '../../utils/displayUtils'

interface ForfeitureReasonTableProps {
  data: ForfeitureReasonDTO[];
  handleEdit: (row: ForfeitureReasonDTO) => void;
  handleDelete: (row: ForfeitureReasonDTO) => void;
  currentPage: number;
  totalPages: number;
  setCurrentPage: (page: number) => void;
  pageSize: number;
  setPageSize: (size: number) => void;
  isLoading: boolean;
}

const ForfeitureReasonTable: React.FC<ForfeitureReasonTableProps> = ({
  data,
  handleEdit,
  handleDelete,
  currentPage,
  totalPages,
  setCurrentPage,
  pageSize,
  setPageSize,
  isLoading,
}) => {
  return (
    <Table
      columns={[
                
                    {
                        label: "Title",
                        key: "title",
                    },
        
                    {
                        label: "Display Position",
                        key: "displayPosition",
                    },
        
                    {
                        label: "Is Active",
                        key: "isActive",
                        render: (row: ForfeitureReasonDTO) => renderBooleanBadge(row.isActive ?? false),
                    },
        
                {
                    label: "Added",
                    key: "createdUtc",
                    format: (value: Date) => convertToUserTime(value?.toString() ?? ''),
                },

      ]}
      data={data}
      actions={{
        onEdit: handleEdit,
        onDelete: handleDelete,
      }}
      currentPage={currentPage}
      totalPages={totalPages}
      onPageChange={setCurrentPage}
      pageSize={pageSize}
      onPageSizeChange={setPageSize}
      isLoading={isLoading}
    />
  );
};

export default ForfeitureReasonTable;
